// extracted by mini-css-extract-plugin
export default {"statsSection":"Consultation_statsSection__PWcc+"};